import { TableCell, Box, TableSortLabel, useTheme } from '@mui/material'
import { Column, SortOrder } from './SmartTableDefinitions'
import { useRef, useState } from 'react'
import Helper from '../../../helpers/Helper'

interface CellProps {
    column: Column
    orderBy?: string
    order?: SortOrder
    onSort?: (column: Column) => void
}

function SmartTableHeaderColumns({ column, orderBy, order, onSort }: CellProps) {
    const theme = useTheme()
    const isResizing = useRef(false)
    const startX = useRef(0)
    const startWidth = useRef(0)
    const [width, setWidth] = useState(Number(column.width) || 110)

    const handleMouseMove = (e: MouseEvent) => {
        if (isResizing.current) {
            const deltaX = e.clientX - startX.current
            const newWidth = Math.max(startWidth.current + deltaX, 50)
            setWidth(newWidth)
        }
    }

    const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
        isResizing.current = false
    }

    const handleMouseDown = (e: React.MouseEvent) => {
        isResizing.current = true
        startX.current = e.clientX
        startWidth.current = width
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleMouseUp)
    }

    return (
        <TableCell
            align={column.numeric ? 'right' : 'left'}
            sortDirection={orderBy === column.id ? order : false}
            sx={{
                padding: 2,
                paddingLeft: 4,
                fontSize: '14px',
                fontWeight: 'bold',
                backgroundColor: theme.palette.background.smartable,
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.divider}`,
                position: 'relative',
                minWidth: column.minWidth,
                maxWidth: column.maxWidth,
                width: width
            }}>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
                <span>{Helper.hasVal(column.render) ? column.render : column.label}</span>
                <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : 'asc'}
                    onClick={() => onSort && onSort(column)}
                    sx={{
                        '& .MuiTableSortLabel-icon': {
                            opacity: 1,
                            fontSize: '12px',
                            color: theme.palette.text.secondary
                        }
                    }}
                />
            </Box>
            <div
                style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    cursor: 'col-resize',
                    zIndex: 1
                }}
                onMouseDown={handleMouseDown}
            />
        </TableCell>
    )
}

export default SmartTableHeaderColumns
